import React, { useMemo } from 'react';
import './styles.scss';
import { useConfigStore } from '@/hooks/stores';
import { Avatar } from '../Avatar';
import { useCustomComponent } from '@/hooks';
import Components from './components';

export interface AvatarsProps {}

const AvatarsComponent: React.FC<AvatarsProps> = () => {
  const {
    theme: {
      branding: { avatars },
    },
  } = useConfigStore();

  // Shuffle avatars once on mount for random order each page load
  const shuffledAvatars = useMemo(() => {
    if (!avatars?.length) return [];
    const arr = [...avatars];
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }, [avatars]);

  if (!shuffledAvatars.length) return null;

  return (
    <Components.AvatarsContainer>
      {shuffledAvatars.map((avatar, index) => (
        <Components.AvatarsItem
          key={`${avatar.url}-${index}`}
          style={{
            marginRight: index !== shuffledAvatars.length - 1 ? 'min(-5%, -8px)' : '0',
            zIndex: shuffledAvatars.length - index,
          }}
        >
          <Avatar {...avatar} />
        </Components.AvatarsItem>
      ))}
    </Components.AvatarsContainer>
  );
};

export const Avatars: React.FC<AvatarsProps> = (props: AvatarsProps) => {
  const Component = useCustomComponent({
    componentName: 'Avatars',
    Component: AvatarsComponent,
  });

  return <Component {...props} />;
};
